
import EDC from '../../../shared/globals';
import { Question } from '../../../shared/question';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.SoundsSorting.GameData;
  this.answersCount = 4;
  this.frameContainer = null;
  this.taskContainer = null;
  this.iteration = -1;
  this.tasks = [];
  this.taskZoneHeight = 680;
  this.taskZoneWidth = 1090;
  this.questionMark = null;
  this.doneX = 20;
  this.doneY = 30;
  this.doneTasks = [];
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.SequencingFrame.Scenes.Main.prototype.constructor = EDC.Games.SequencingFrame.Scenes.Main;
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.create = function () {
  this.initialize();

  this.addFrameContainer();
  this.addTaskContainer();

  this.add.sprite(this.game.config.width / 2, 1020, 'title');

  this.questionMark = new Question(this);
  this.questionMark.create(this.doneX, this.doneY);

  // eslint-disable-next-line max-len
  this.iteration = this.gameConfig.order === EDC.SortTypes.ST_ASCENDING ? 0 : this.gameConfig.iterations;
  this.showCompletedIteration();

  this.loadNextIteration();

  this.createBasicUI();
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.addFrameContainer = function () {
  this.frameContainer = this.add.container(600, 5);
  const frame = this.add.sprite(0, 0, 'frame').setOrigin(0, 0);
  const title = this.add.sprite(frame.width / 2, 115, 'frame-title');

  this.frameContainer.add(frame);
  this.frameContainer.add(title);
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.addTaskContainer = function () {
  const fx = this.frameContainer.x;
  const fy = this.frameContainer.y;
  this.taskContainer = this.add.container(fx + 90, fy + 190);
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.nextIterationValue = function () {
  if (this.iteration === -1) {
    // eslint-disable-next-line max-len
    this.iteration = this.gameConfig.order === EDC.SortTypes.ST_ASCENDING ? 0 : this.gameConfig.iterations;
  } else {
    this.iteration += this.gameConfig.order === EDC.SortTypes.ST_ASCENDING ? 1 : -1;
  }
  // eslint-disable-next-line max-len
  if (this.gameConfig.order === EDC.SortTypes.ST_ASCENDING && this.iteration > this.gameConfig.iterations) {
    return true;
  } else if (this.gameConfig.order === EDC.SortTypes.ST_DESCENDING && this.iteration < 0) {
    return true;
  }
  return false;
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.loadNextIteration = function () {
  const isGameCompleted = this.nextIterationValue();
  if (isGameCompleted) {
    setTimeout(() => {
      this.tasks.forEach((elem) => {
        elem.removeInteractive();
      });
      this.cursorManager.resetCursor();
      this.showSummary();
    }, 500);
  } else {
    const taskSlotHeight = this.taskZoneHeight / this.answersCount;
    const iterationData = this.generateDataForIteration(this.iteration);
    // load iteration task
    for (let i = 0; i < iterationData.length; i++) {
      const task = this.add.container(this.taskZoneWidth / 2,
        i * taskSlotHeight + taskSlotHeight / 2);
      const sprite = this.add.sprite(0, 0, `task-${iterationData[i]}`);
      task.add(sprite);
      this.taskContainer.add(task);

      task.setData('isActive', true);
      task.setData('index', iterationData[i]);
      const markAnim = new AnswerMark(this, task).setScale(0.45);
      task.setData('markAnim', markAnim);

      task.setSize(sprite.width, sprite.height);
      task.setInteractive();
      task.on('pointerup', this.onTaskUp.bind(this, task));
      this.cursorManager.setDefaultDraggableEvents(task);

      this.tasks.push(task);
    }
  }
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.onTaskUp = function (task) {
  task.removeInteractive();
  const taskIndex = task.getData('index');
  if (taskIndex === this.iteration) {
    this.tasks.forEach((elem) => {
      elem.removeInteractive();
    });
  }
  if (!task.getData('isActive')) return;
  this.tweens.add({
    targets: task,
    scaleX: 0.9,
    scaleY: 0.9,
    duration: 100,
    ease: 'Linear',
    yoyo: true,
    onComplete: this.checkAnswer.bind(this, task),
  });
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.generateDataForIteration = function (iteration) {
  const sourceData = this.getSourceArray();

  const ci = sourceData.indexOf(iteration);
  if (ci >= 0) {
    sourceData.splice(ci, 1);
  }

  const generatedData = [];
  for (let i = 0; i < this.answersCount; i++) {
    generatedData.push(this.getRandomValueFromArray(sourceData));
  }

  const rndIdx = Math.floor(Math.random() * generatedData.length);
  generatedData[rndIdx] = iteration;

  return generatedData;
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.checkAnswer = function (task) {
  const taskIndex = task.getData('index');
  if (taskIndex === this.iteration) {
    task.getData('markAnim').showMark(true, this.correctAnswer.bind(this));
    this.playCorrect();
  } else {
    task.getAt(0).setTint(0xff0000);
    task.getData('markAnim').showMark(false, this.deactivateTask.bind(this, task));
    this.playWrong();
  }
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.correctAnswer = function () {
  this.destroyTasks();
  this.showCompletedIteration();
  this.loadNextIteration();
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.destroyTasks = function () {
  for (let i = 0; i < this.tasks.length; i++) {
    this.tasks[i].destroy();
  }
  this.tasks = [];
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.deactivateTask = function (task) {
  task.setData('isActive', false);
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.getRandomValueFromArray = function (targetArray) {
  const rndIdx = Math.floor(Math.random() * targetArray.length);
  const res = targetArray.splice(rndIdx, 1);
  return res[0];
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.getSourceArray = function () {
  const source = [];
  for (let i = 0; i <= this.gameConfig.iterations; i++) {
    source.push(i);
  }
  return source;
};
/**
 *
 */
EDC.Games.SequencingFrame.Scenes.Main.prototype.showCompletedIteration = function () {
  const doneContainer = this.add.container(this.doneX, this.doneY);
  const doneSprite = this.add.sprite(0, 0, `done-${this.iteration}`).setOrigin(0, 0);
  const doneBgLeft = this.add.sprite(0, 0, 'done-bg-left').setOrigin(0, 0);
  const doneBgRight = this.add.sprite(0, 0, 'done-bg-right').setOrigin(0, 0);
  const doneBgMiddle = this.add.sprite(0, 0, 'done-bg-middle').setOrigin(0, 0);
  const neededMiddleWidth = doneSprite.width - doneBgLeft.width - doneBgRight.width + 30;

  doneBgMiddle.setDisplaySize(neededMiddleWidth, doneBgMiddle.height);
  doneBgMiddle.x = doneBgLeft.x + doneBgLeft.width;

  doneBgRight.x = doneBgMiddle.x + doneBgMiddle.displayWidth;

  doneContainer.add([doneBgLeft, doneBgMiddle, doneBgRight]);

  let doneBounds = doneContainer.getBounds();
  doneSprite.y = (doneBounds.height - doneSprite.height) / 2;
  doneSprite.x = (doneBounds.width - doneSprite.width) / 2;
  doneContainer.add(doneSprite);

  doneBounds = doneContainer.getBounds();

  if (this.doneTasks.length) {
    const { x } = this.doneTasks[this.doneTasks.length - 1];
    const { y } = this.doneTasks[this.doneTasks.length - 1];
    doneContainer.setPosition(x, y + doneBounds.height);
  }

  this.doneTasks.push(doneContainer);
  this.questionMark.moveTo(this.questionMark.getX(), this.questionMark.getY() + doneBounds.height);
};

export default EDC.Games.SequencingFrame.Scenes.Main;
